var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOverlappingSquares(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 125,
    viewBox: "0 0 125 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M103.529 46.6172H57.0286C51.3217 46.6172 46.6953 51.2436 46.6953 56.9505V103.451C46.6953 109.157 51.3217 113.784 57.0286 113.784H103.529C109.236 113.784 113.862 109.157 113.862 103.451V56.9505C113.862 51.2436 109.236 46.6172 103.529 46.6172Z",
    stroke: "white",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0286 77.6169H20.862C18.1214 77.6169 15.4931 76.5282 13.5552 74.5903C11.6173 72.6524 10.5286 70.0241 10.5286 67.2835V20.7835C10.5286 18.043 11.6173 15.4146 13.5552 13.4768C15.4931 11.5389 18.1214 10.4502 20.862 10.4502H67.362C70.1025 10.4502 72.7308 11.5389 74.6687 13.4768C76.6066 15.4146 77.6953 18.043 77.6953 20.7835V25.9502",
    stroke: "white",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverlappingSquares);
export default __webpack_public_path__ + "static/media/overlapping-squares.42fef02dbaf5e7204e7f19fce9b83faf.svg";
export { ForwardRef as ReactComponent };